import { DataComparison } from "./DataComparison";
import { DeviceBit } from "./DeviceBit";
import { DeviceRg } from "./DeviceRg";
import { Ecart } from "./Ecart";
import { StatutIncident } from "./StatuIncident";
import { Syncro } from "./Syncro";
import { TypeIncident } from "./TypeIncident";

export class Incident{
  idIncident?: number;
  description?: string;
  dateIncident?: Date;
  dateResolution?: Date;
  ecart?: Ecart;
  syncro?: Syncro;
  comparison?: DataComparison;
  deviceBit?: DeviceBit;
  deviceRg?: DeviceRg;
  typeIncident?: TypeIncident;
  isDeleted?: boolean;
  statutIncident?: StatutIncident;
  clientRgMissing?: string;
  clientBitMissing?: string;
  osMissing?: string;
}
